/*
 se llama un svg puro y dinámico para mostrar iconos personalizados
 se pueden transformar desde aquí https://react-svgr.com/playground/?icon=true
 tutorial aquí https://www.youtube.com/watch?v=wVtV8l7FIi0
*/

const RabbitIcon = props => {
	const { color = '' } = props
	return (
		<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 34 19' width='1em' height='1em' {...props}>
			<g fill={color}>
				<path
					data-name='Trazado 43735'
					d='M4.091 15.287h4.928a.262.262 0 1 1 0 .523H4.081a.262.262 0 1 1 0-.523Z'
				/>
				<path
					data-name='Trazado 43736'
					d='M6.131 17.366h2.893a.262.262 0 1 1 0 .523h-2.9a.262.262 0 1 1 0-.523Z'
				/>
				<path
					data-name='Trazado 43737'
					d='M1.983 15.287h.523a.262.262 0 1 1 0 .523h-.523a.262.262 0 1 1 0-.523Z'
				/>
				<path
					data-name='Trazado 43738'
					d='M.811 15.287h.1a.262.262 0 0 1 0 .523H.804a.262.262 0 1 1 0-.523Z'
				/>
				<path
					data-name='Trazado 43739'
					d='M9.019 5.894H4.081a.262.262 0 1 1 0-.523h4.938a.262.262 0 1 1 0 .523Z'
				/>
				<path
					data-name='Trazado 43740'
					d='M9.024 3.815H7.769a.262.262 0 1 1 0-.523h1.255a.262.262 0 0 1 0 .523Z'
				/>
				<path
					data-name='Trazado 43741'
					d='M5.859 9.363a.262.262 0 0 1-.262.262H1.046a.262.262 0 0 1 0-.523h4.551a.262.262 0 0 1 .262.261Z'
				/>
				<path
					data-name='Trazado 43742'
					d='M4.013 11.003h2.354a.262.262 0 1 1 0 .523H4.013a.262.262 0 0 1 0-.523Z'
				/>
				<path
					data-name='Trazado 43743'
					d='M1.983 5.894a.262.262 0 1 1 0-.523h.523a.262.262 0 1 1 0 .523Z'
				/>
				<path
					data-name='Trazado 43744'
					d='M.262 5.371h.107a.262.262 0 0 1 0 .523H.262a.262.262 0 1 1 0-.523Z'
				/>
				<path
					data-name='Trazado 43745'
					d='M27.856 5.483a1.054 1.054 0 1 1-1.457.343l.008-.013a1.046 1.046 0 0 1 1.441-.335Zm-1.08 1.007a.205.205 0 1 1 .005 0Z'
				/>
				<path
					data-name='Trazado 43746'
					d='M25.258 3.085a3.812 3.812 0 0 0-.361.162.262.262 0 0 1-.282-.034 12.3 12.3 0 0 0-4.182-2.21.262.262 0 0 1 .152-.5 12.692 12.692 0 0 1 4.232 2.218 5.038 5.038 0 0 1 2.44-.541 5.94 5.94 0 0 1 5.493 8.249.056.056 0 0 1 0 .021 5.133 5.133 0 0 1-1.892 2.367 3 3 0 0 1-.84.393 6.84 6.84 0 0 1-4.179-.1l-.073.123a8.712 8.712 0 0 1-3 2.83 5.538 5.538 0 0 1 .8 2.255.262.262 0 0 1-.17.262 7.82 7.82 0 0 1-2.668.434 11.608 11.608 0 0 1-3.74-.659l-2.84 1.067a2.129 2.129 0 0 1-2.743-1.241l-.031-.084a2.132 2.132 0 0 1 .965-2.616 6.138 6.138 0 0 1-.863-1 5.556 5.556 0 0 1-.439-.785 1.781 1.781 0 0 1-.609.11 1.76 1.76 0 0 1-1.666-1.208 2.273 2.273 0 0 1 .209-4.248 1.763 1.763 0 0 1 2.446-.48l.072.051a8.2 8.2 0 0 1 1.146-1.491 9.382 9.382 0 0 1 3.17-2.142 7.191 7.191 0 0 1-2.529-2.935.262.262 0 0 1 .089-.322 7.742 7.742 0 0 1 5.351-.929.264.264 0 0 1-.073.523 7.368 7.368 0 0 0-4.794.73 6.854 6.854 0 0 0 2.616 2.754 8.246 8.246 0 0 0 1.1.552 7.932 7.932 0 0 0 2.092.541.262.262 0 0 1-.029.523h-.036a8.5 8.5 0 0 1-2.221-.578 9.246 9.246 0 0 1-1.007-.5A8.889 8.889 0 0 0 13.003 6.8a6.749 6.749 0 0 0-1.939 3.928 5.213 5.213 0 0 0 .228 2.195c.037.11.076.217.12.322a5.842 5.842 0 0 0 .523.918 8.054 8.054 0 0 0 1.015 1.174 11.247 11.247 0 0 0 3.57 2.291 9.76 9.76 0 0 0 6.5.523 5.156 5.156 0 0 0-.838-2.053 7.4 7.4 0 0 0-3.34-2.639 7.937 7.937 0 0 0-1.86-.523.264.264 0 1 1 .076-.523 8.516 8.516 0 0 1 1.98.547c.238.1.466.207.691.322a3.387 3.387 0 1 0-4.915-4.584.262.262 0 1 1-.444-.277.281.281 0 0 1 .028-.037 3.91 3.91 0 1 1 5.812 5.189 7.726 7.726 0 0 1 2.262 2.051 8.228 8.228 0 0 0 2.82-2.726l.016-.031a5.985 5.985 0 0 1-2.974-2.851.262.262 0 0 1 .473-.225 5.494 5.494 0 0 0 2.885 2.681 5.8 5.8 0 0 0 4.522.108 3.9 3.9 0 0 0 .523-.34 3.065 3.065 0 0 1-2.67-1.569.263.263 0 1 1 .455-.262 2.545 2.545 0 0 0 2.691 1.261.261.261 0 0 1 .139.016 4.987 4.987 0 0 0 .772-1.135c-.9-.123-1.527-.562-1.527-1.114 0-.243.123-.56.709-.675a7.135 7.135 0 0 1 1.263-.063h.1a5.216 5.216 0 0 0 0-1.125 5.477 5.477 0 0 0-5.4-4.881 4.589 4.589 0 0 0-2.006.392Zm7.305 6.136a7.059 7.059 0 0 0-1.159.055c-.285.055-.285.131-.285.16 0 .222.463.539 1.221.609a5.832 5.832 0 0 0 .223-.823Zm-21.33-.829a1.235 1.235 0 0 0-1.87.314.247.247 0 0 1-.15.116 1.753 1.753 0 0 0-.137 3.341.24.24 0 0 1 .152.171 1.234 1.234 0 0 0 1.2.937 1.258 1.258 0 0 0 .405-.068 4.313 4.313 0 0 1-.285-2.566 6.636 6.636 0 0 1 .675-2.244Zm.667 8.294a1.59 1.59 0 0 0-.042 1.229l.034.089a1.6 1.6 0 0 0 2.066.935h.009l2.286-.858a11.883 11.883 0 0 1-3.494-2.213 1.582 1.582 0 0 0-.859.818Z'
				/>
				<path
					data-name='Trazado 43747'
					d='M21.188 4.652a.261.261 0 0 1-.262.2h-.06c-.154-.037-3.824-.9-5.16-2.354a.262.262 0 0 1 .379-.35c1.229 1.323 4.86 2.181 4.9 2.189a.261.261 0 0 1 .208.306Z'
				/>
			</g>
		</svg>
	)
}

export default RabbitIcon
